var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWsaVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 1240,
    viewBox: "0 0 277 1240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.25H216.319L277 1298.75H0V-0.25Z",
    fill: "#084AA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsaVector1);
export default __webpack_public_path__ + "static/media/wsa_vector1.5cd34482f981d201d98cc7e6008b9736.svg";
export { ForwardRef as ReactComponent };